// extracted by mini-css-extract-plugin
export var h1 = "MarkdownElements-module--h1--a847f";
export var h2 = "MarkdownElements-module--h2--5d0d1";
export var h3 = "MarkdownElements-module--h3--2eadf";
export var h4 = "MarkdownElements-module--h4--25ab8";
export var h5 = "MarkdownElements-module--h5--9fef9";
export var h6 = "MarkdownElements-module--h6--d0fc3";
export var table = "MarkdownElements-module--table--8382c";
export var tableWrap = "MarkdownElements-module--tableWrap--72ac6";